<template>
  <b-container fluid>
    <b-row class="pb-2">
      <b-col sm="4">
        <h3>
          <b-badge variant="primary">
            Change Password
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col sm="4" class="pb-2 pb-sm-0" order="3" order-sm="2">
        <b-button
          :disabled="!canSubmit || waiting"
          block
          variant="success"
          type="submit"
          @click="changePW">
          Submit change
        </b-button>
      </b-col>
      <b-col sm="4" class="pb-2 pb-sm-0" order="2" order-sm="3">
        <b-button 
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <!-- current password -->
    <b-form-group
      class="pt-2"
      id="input-group-current"
      label="Current password"
      label-for="input-current"
      label-cols-sm="3"
      invalid-feedback="cannot be blank">
      <b-form-input
        id="input-current"
        :state="validateCurrent"
        v-model="currentPW"
        type="password"
        placeholder="enter current password">
      </b-form-input>
    </b-form-group>
    <!-- new password -->
    <b-form-group
      id="input-group-new"
      label="New password"
      label-for="input-new"
      label-cols-sm="3"
      :invalid-feedback="passwordStrengthMessage">
      <b-form-input
        :state="passwordStrongEnough"
        id="input-new"
        v-model="newPW"
        type="password"
        placeholder="enter a new password">
      </b-form-input>
    </b-form-group>
    <!-- confirm new password -->
    <b-form-group
      id="input-group-confirm"
      label="Re-enter new password"
      label-for="input-confirm"
      label-cols-sm="3"
      :invalid-feedback="passwordFeedback">
      <b-form-input
        :state="newPasswordsMatch && validateConfirm"
        id="input-confirm"
        v-model="confirmNewPW"
        type="password"
        placeholder="confirm new password">
      </b-form-input>
    </b-form-group>
    <!-- OTP -->
    <b-row>
      <b-col cols="12" sm="9">
        <b-form-group
          id="input-group-otp"
          label="OTP"
          label-for="input-otp"
          label-cols-sm="4"
          invalid-feedback="cannot be blank">
          <b-form-input
            id="input-otp"
            :state="validateOTP"
            v-model="OTP"
            type="text"
            placeholder="enter OTP">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-button
          block
          :disabled="waiting"
          @click="requestPWChangeOTP">
          <b-spinner 
            v-if="waiting" 
            small 
            label="Loading...">
          </b-spinner>
          Request OTP
        </b-button>
      </b-col>
    </b-row>  
  </b-container>
</template>

<script>
import { authService } from '../_services';
import { checkPasswordStrength } from '../_helpers'

export default {
  data() {
    return {
      waiting: false,
      OTP: '',
      currentPW: '',
      newPW: '',
      confirmNewPW: '',
    }
  },
  methods: {
    changePW() {
      this.waiting = true
      let vm = this
      authService.changePassword(this.currentPW, this.newPW, this.OTP)
      .then((resp) => {
        console.log(resp.data)
        vm.$bvModal.msgBoxOk(resp.data)
        vm.waiting = false
      })
      .catch((err) => {
        vm.$bvModal.msgBoxOk('unexpected error')
        vm.waiting = false
      })
    },
    requestPWChangeOTP() {
      this.waiting = true
      let vm = this
      authService.requestPWChangeOTP()
      .then((resp) => {
        vm.waiting = false
      })
      .catch((err) => {
        vm.$bvModal.msgBoxOk('OTP not sent')
        vm.waiting = false
      })
    }
  },
  computed: {
    passwordStrengthMessage() {
      return checkPasswordStrength(this.newPW)
    },
    passwordStrongEnough() {
      return checkPasswordStrength(this.newPW) === ''
    },
    canSubmit() {
      return this.validateCurrent && 
        this.passwordStrongEnough &&
        this.validateConfirm && 
        this.validateOTP && 
        this.newPasswordsMatch
    },
    validateCurrent() {
      return this.currentPW !== ''
    },
    validateConfirm() {
      return this.confirmNewPW !== '' && this.newPasswordsMatch //&& this.passwordStrongEnough
    },
    validateOTP() {
      return this.OTP !== ''
    },
    newPasswordsMatch() {
      return this.newPW === this.confirmNewPW && this.newPW !== ''
    },
    passwordFeedback() {
      if (this.newPW !== this.confirmNewPW) {
        return 'passwords must match'
      }
      return 'password cannot be blank'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ChangePasswordPage.vue